class CartDrawer extends SlidingDrawer {
  constructor() {
    super();
    this.overlayElement = this.querySelector(".js-cart-overlay");
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.closeDrawer()
    );

    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.closeDrawer.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.openCartOnUrlParams();
  }
  openCartOnUrlParams() {
    if (!window.URLSearchParams) {
      console.warn("does not work in IE11");
      return;
    }

    const searchParams = new window.URLSearchParams(window.location.search);

    if (searchParams.get("cart") === "open") {
      this.openDrawer();
    }
  }
  setHeaderCartIconAccessibility() {
    // const cartLink = document.querySelector("#cart-icon");
    // cartLink.setAttribute("role", "button");
    // cartLink.setAttribute("aria-haspopup", "dialog");
    // cartLink.addEventListener("keydown", (event) => {
    //   if (event.code.toUpperCase() === "SPACE") {
    //     event.preventDefault();
    //     this.open(cartLink);
    //   }
    // });
  }
  bindEvents() {
    document.querySelector(".js-cart-drawer-toggle").addEventListener(
      "click",
      this.onDrawerToggleClick.bind(this)
    );
  }

  openDrawer() {
    setTimeout(() => {
      this.drawerToggle.classList.add("drawer-opening");
    });
    this.drawerToggle.setAttribute("aria-expanded", true);
    this.drawerElement.removeAttribute('inert');
    this.setAttribute("data-open", "");
    this.drawerElement.classList.add("drawer--open");
    this.overlayElement.classList.add("drawer--open");

      // Enable tabbing only on elements inside the drawer
      enableTabbing(this.drawerElement);

    // Apply focus trap
    trapFocus(this.drawerElement);
    document.body.classList.add("overflow-hidden");
    document.body.classList.add("mini-cart-open");
  }

  closeDrawer() {
    this.drawerElement.classList.remove("drawer--open");
    this.overlayElement.classList.remove("drawer--open");
    this.drawerToggle.classList.remove("drawer-opening");
    this.drawerToggle.setAttribute("aria-expanded", false);
    this.drawerElement.setAttribute('inert', '');
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('mini-cart-open');

      // Disable tabbing on elements inside the drawer
    disableTabbing(this.drawerElement);

    // remove trap focus
    removeTrapFocus(this.activeElement);

    this.closeAnimation();
  }

  onFocusOut() {}

  renderContents(parsedState) {
    this.querySelector(".js-cart-drawer-inner").classList.contains(
      "is-empty"
    ) &&
      this.querySelector(".js-cart-drawer-inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.closeDrawer.bind(this)
      );
      this.openDrawer();
    });
  }

  async renderContentsSilent() {
    const sectionsToRender = this.getSectionsToRender();
    const sectionIds = sectionsToRender.map((section) => section.id);

    try {
      const response = await fetch("/?sections=" + sectionIds.join(","), {
        cache: "no-store",
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!response.ok) return;
      const sections = await response.json();

      sectionsToRender.forEach((section) => {
        const target = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        const html = sections[section.id];
        if (!target || !html) return;
        target.innerHTML = this.getSectionInnerHTML(html, section.selector);
      });

      // Sync `is-empty` class on the wrapper elements with the freshly-
      // rendered state. The empty-state markup contains
      // `.js-cart-drawer-inner-empty`, so its presence indicates an empty cart.
      const inner = this.querySelector(".js-cart-drawer-inner");
      if (inner) {
        const isEmpty = !!inner.querySelector(".js-cart-drawer-inner-empty");
        inner.classList.toggle("is-empty", isEmpty);
        this.classList.toggle("is-empty", isEmpty);
      }

      // If bfcache captured an open drawer, close it — the user opened it on
      // a different page, not the one they're returning to.
      if (this.drawerElement && this.drawerElement.classList.contains("drawer--open")) {
        this.closeDrawer();
      }
    } catch (err) {
      console.warn("[cart-drawer] silent refresh failed", err);
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".js-cart-drawer-inner",
      },
      {
        id: "cart-icon",
        section: "cart-icon",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);


// Refresh cart drawer + cart icon when the browser replays a cached snapshot
// on back/forward navigation (bfcache or HTTP cache). Cart state isn't part
// of the captured DOM, so without this the user sees a stale minicart.
window.addEventListener("pageshow", (event) => {
  const nav = performance.getEntriesByType("navigation")[0];
  const fromCache =
    event.persisted ||
    (nav && nav.type === "back_forward" && nav.transferSize === 0);
  if (!fromCache) return;

  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) cartDrawer.renderContentsSilent();
});

//custom Mod Bundles add to cart
document.addEventListener("cart:updated", async (event) => {
  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return;

  const sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id);
  const sectionsUrl = window.location.pathname;

  try {
    const response = await fetch("/?sections=" + sectionsToRender.join(","), {
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    });

    const data = await response.json();

    // Re-render cart drawer contents
    cartDrawer.renderContents({
      id: 'cart',
      sections: data,
      sectionsUrl: sectionsUrl
    });

    // Poll for the button to reappear and click it
    const openDrawerWhenReady = () => {
      const trigger = document.querySelector('[aria-controls="CartDrawer"]');
      if (trigger) {
        trigger.click();
      } else {
        requestAnimationFrame(openDrawerWhenReady);
      }
    };

    openDrawerWhenReady();

  } catch (err) {
    console.error("Cart drawer update + open failed:", err);
  }
});